import URLHelper from './url-helper';

export default {
  editCelebrationProgram(celebrationProgram, args = {}) {
    return URLHelper.build(`/celebrations/${celebrationProgram.id}/edit`, args);
  },
};
